import {useState} from "react";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from "@mui/material";
import CustomDialog from "../../../../../components/Dialog/DiaCompMedium";
import ApoTextInfo from "./ApoTextInfo";



export default function DiaInfoApo() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
    <Tooltip title="Info" placement="left">
        <IconButton onClick={handleOpen} size="small">
              <InfoIcon sx={{ '&:hover': { transform: 'scale(1.1)', color: 'quartiary.main', } }}/>
        </IconButton>   
    </Tooltip>

<CustomDialog open={open} onClose={handleClose}

    title="APOE polymorphism - longevity variants / alleles"
    content = {<ApoTextInfo />}
/>

</>
)}